// src/mixins/languageMixin.js

import ElementLocale from 'element-ui/lib/locale';
// 引入 Element UI 各语言包
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import frLocale from 'element-ui/lib/locale/lang/fr';
import jaLocale from 'element-ui/lib/locale/lang/ja';

// Element UI 语言包映射
const elementUILocales = {
    'en': enLocale,
    'zh': zhLocale, // Element UI 中文是 zh-CN
    'fr': frLocale,
    'ja': jaLocale,
};

export default {
    methods: {
        /**
         * 切换应用语言
         * @param {string} lang - 语言代码 ('en', 'zh', 'fr', 'ja')
         */
        switchLanguage(lang) {
            // 如果当前语言与要切换的语言不同
            if (this.$i18n.locale !== lang) {
                this.$i18n.locale = lang; // 设置 vue-i18n 的当前语言
                localStorage.setItem('language', lang); // 将选择的语言保存到 localStorage

                // 设置 Element UI 的语言
                // 查找对应的 Element UI 语言包，如果找不到则默认使用英文
                const elLocale = elementUILocales[lang] || enLocale;
                ElementLocale.use(elLocale);

                // 可以在这里添加其他需要响应语言切换的逻辑
                console.log(`Language switched to: ${lang}`);
            }
        },
        /**
         * 获取当前语言
         * 从 localStorage 中获取保存的语言，如果不存在则默认为 'en'
         * @returns {string} 当前语言代码
         */
        getCurrentLanguage() {
            return localStorage.getItem('language') || 'en';
        }
    }
};
